var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarZ = function SvgDefaultAvatarZ(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "default-avatar_z_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".default-avatar_z_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9 55.7c1.9 0 3.6-5 3.6-8.1 0-1.8-.6-2.6-1.4-2.6s-1.3 1.1-1.9 3.4c-.3 1-.5 1.9-1.1 2.8-.6.8-4 1.1-6.4 1.1H34c5.2-7.7 11.3-16.3 17.2-24.1.5-.6.6-1.1.6-1.6 0-.7-.5-1.4-1.6-1.4-1.6 0-3.2.1-5.3.1H34.3c-1.8 0-1.6-.7-2.7-.7-1.8 0-3.3 4.7-3.3 7.8 0 1.6.5 2.6 1.3 2.6.9 0 1.3-1.1 1.9-3.1.3-1.3.7-2.1 1.1-2.7.5-.8 4-1 6.8-1h5.8c-5.5 7.5-11.9 16.4-16.9 23.9-.4.6-.7 1.2-.7 1.8 0 .8.5 1.4 1.8 1.4 1.6 0 3.1-.1 5.1-.1h11.7c1.7-.2 1.4.5 2.7.5z"
  })));
};
export default SvgDefaultAvatarZ;